import { DEFAULT_PHONE, isPhoneComplete, normalizePhone } from "./phoneUtils";

const isEmergencyPhone = (entry) =>
  String(entry?.type ?? "").trim().toLowerCase() === "emergency";

export const isUserContactRecord = (formValues = {}) =>
  Object.prototype.hasOwnProperty.call(formValues, "userType") ||
  Object.prototype.hasOwnProperty.call(formValues, "staffId") ||
  Object.prototype.hasOwnProperty.call(formValues, "personalEmail") ||
  Object.prototype.hasOwnProperty.call(formValues, "emergencyContactNo");

const completePhones = (phones) =>
  (Array.isArray(phones) ? phones : []).filter((phone) => isPhoneComplete(phone));

const defaultEntry = (items) =>
  items.find((item) => item?.isDefault) ?? items[0] ?? null;

const secondEntry = (items, first) =>
  items.find((item) => item !== first) ?? null;

/**
 * Legacy phone / phone2 / emergencyContactNo mirror the contact list.
 * Clearing a row has to update those fields too, or the next save copies
 * the removed number back into the list.
 */
export const legacyPhoneFieldsFromList = (phones, formValues = {}) => {
  const stored = completePhones(phones);
  const user = isUserContactRecord(formValues);
  const primary = user
    ? stored.filter((phone) => !isEmergencyPhone(phone))
    : stored;
  const first = defaultEntry(primary);
  const second = secondEntry(primary, first);
  const emergency = stored.find((phone) => isEmergencyPhone(phone));

  const patch = {
    phone: first ? normalizePhone(first) : { ...DEFAULT_PHONE },
    phone2: second ? normalizePhone(second) : { ...DEFAULT_PHONE },
  };

  if (user) {
    patch.emergencyContactNo = emergency
      ? normalizePhone(emergency)
      : { ...DEFAULT_PHONE };
  }

  return patch;
};

const completeEmails = (emails) =>
  (Array.isArray(emails) ? emails : []).filter((email) => email?.value?.trim());

export const legacyEmailFieldsFromList = (emails, formValues = {}) => {
  const stored = completeEmails(emails);
  const user = isUserContactRecord(formValues);
  const personal = stored.find(
    (email) => String(email?.type ?? "").trim().toLowerCase() === "personal"
  );
  const chosen = user ? personal ?? defaultEntry(stored) : defaultEntry(stored);
  const value = chosen?.value?.trim() ?? "";

  if (user) return { personalEmail: value };
  return { email: value };
};
